import { createSvgIcon } from '@automata/mui-theme';
export const ScanBarcodeIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 23H32V26H16V23Z" />
    <path d="M80 23V39H77V23L80 23Z" />
    <path d="M80 73H64V70H80V73Z" />
    <path d="M16 39V23L19 23L19 39H16Z" />
    <path d="M64 23H80V26H64V23Z" />
    <path d="M80 57V73H77V57H80Z" />
    <path d="M16 73L16 57H19L19 73H16Z" />
    <path d="M32 73H16L16 70H32V73Z" />
    <path d="M26 38H30V58H26V38Z" />
    <path d="M33 38H35V58H33V38Z" />
    <path d="M38 38H42V58H38V38Z" />
    <path d="M45 38H47V58H45V38Z" />
    <path d="M50 38H54V58H50V38Z" />
    <path d="M57 38H59V58H57V38Z" />
    <path d="M62 38H66V58H62V38Z" />
    <path d="M69 38H71V58H69V38Z" />
  </svg>,
  'ScanBarcodeIcon'
);
